import { createSlice } from '@reduxjs/toolkit';
import { fetchAdditionalsOrder } from '.';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const additionals = createSlice({
  name: 'additionals',
  initialState,
  reducers: {
    // reducers goes here

    addAdditionals: (state, action) => {
      if (state.data.violations) {
        state.data.violations = [...state.data.violations, action.payload];
      } else {
        let violationsArray = [action.payload];
        state.data.violations = violationsArray;
      }
    },

    deleteAdditionals: (state, action) => {
      const copyViolationsArray = [...state.data.violations];
      state.data.violations = copyViolationsArray.filter((item) => item.id !== action.payload);
    },

    resetAdditionals: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdditionalsOrder.pending, (state) => {
        state.data = {};
        state.isLoading = true;
      })
      .addCase(fetchAdditionalsOrder.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.errorMessage = action.payload;
      })
      .addCase(fetchAdditionalsOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export const { addViolations, deleteViolations, resetViolations } = additionals.actions;
export default additionals.reducer;
